.quotedMessageContainer {
  display: flex;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  max-width: 100%;
  font-size: 14px;
  margin-bottom: 8px;
  cursor: pointer;
  color: #667781;
  overflow: hidden;
  min-height: 41px;
  align-items: center;
  
  @include themify($themes) {
    @include dark-mode() {
      color: hsla(0, 0%, 100%, 0.6);
    }
  }
  
  .quotedMessageFileContainer {
    pointer-events: none;
    display: flex;
    align-items: center;
    height: 100%;
    a,
    img {
      max-height: 100%;
      border-radius: unset;
      width: 54px;
      min-height: 54px;
      object-fit: cover;
      height: 100%;
      margin-bottom: unset;
    }
  }
}

.quotedLocation {
  font-size: 14px;
}

.qoutedMessageName {
  font-weight: 600;
  font-size: 11px;
}

.quotedMessageText {
  font-weight: 400;
  font-size: 13px;
  display: -webkit-box;
  max-height: 60px;
  overflow: hidden;
  line-height: 20px;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: pre-line;
  
  @include themify($themes) {
    color: themed("neutral-primary");
  }
  svg {
    padding-top: 4px;
  }
}

.quotedMessageBody {
  font-weight: 400;
  font-size: 11px;
  padding: 5px 12px 7px 8px;
  width: 100%;
}


.quotedMessageGeneralFile {
  padding-right: 12px;
}

.quotedMessageAudioContainer {
  display: flex;
  align-items: center;
  width: 100%;
  column-gap: 4px;
}
